export function checkIsRoleAllowed(roleSecurity, userPreferences) {
	if (!roleSecurity) {
		return true;
	}
	let userRoles = userPreferences.ruoliUtente;
	let allowed = true;
	allowed = !roleSecurity.forbidden?.some((role) => userRoles?.some((userRole) => userRole === role));
	if (allowed) {
		return roleSecurity.allowed == null || roleSecurity.allowed.length === 0 || roleSecurity.allowed?.some((role) => userRoles?.some((userRole) => userRole.idRuolo === role));
	}
	return false;
}

export function makeRoleAllowedRule(allowedRoles) {
	let roles = allowedRoles;
	if (!Array.isArray(allowedRoles)) {
		roles = [allowedRoles];
	}
	return { allowed: roles };
}

export function makeRoleForbiddenRule(forbiddenRoles) {
	let roles = forbiddenRoles;
	if (!Array.isArray(forbiddenRoles)) {
		roles = [forbiddenRoles];
	}
	return { forbidden: roles };
}

export function makeRoleSecurityRule(allowedRoles, forbiddenRoles) {
	return { ...makeRoleAllowedRule(allowedRoles), ...makeRoleForbiddenRule(forbiddenRoles) };
}
